/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScalarUnit = {
    ScalarUnitAmount: 'ScalarUnit.Amount'
} as const;
export type ScalarUnit = typeof ScalarUnit[keyof typeof ScalarUnit];


export function ScalarUnitFromJSON(json: any): ScalarUnit {
    return ScalarUnitFromJSONTyped(json, false);
}

export function ScalarUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScalarUnit {
    return json as ScalarUnit;
}

export function ScalarUnitToJSON(value?: ScalarUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ScalarUnit interface.
 */
 export function instanceOfScalarUnit(value: any): value is ScalarUnit {
    return Object.values(ScalarUnit).includes(value)
}

